import './inspect_ctrl';
import './json_editor_ctrl';
import './login_ctrl';
import './invited_ctrl';
import './signup_ctrl';
import './reset_password_ctrl';
import './error_ctrl';
import './home_ctrl';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/controllers/all.ts